// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const OpenPipsSummary = t.struct({
    currentPinsCount: t.Number,
    expiredCount: t.Number,
    pinsExpiringInNext90Days: t.Number
}, {
    name: 'OpenPipsSummary',
    strict: true
});

export const getDefaultState = () => new OpenPipsSummary({
    currentPinsCount: 0,
    expiredCount: 0,
    pinsExpiringInNext90Days: 0
});

export default OpenPipsSummary;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/open-pips-summary.js